if (!customElements.get('product-reviews')) {
  customElements.define(
    'product-reviews',
    class ProductReviews extends HTMLElement {
      constructor() {
        super();

        this.expand = this.querySelector('.reviews-expand');

        if (this.expand) {
          this.expand.addEventListener('click', () => {
            this.setAttribute('data-expanded', true);
          });
        }
      }
    }
  );
}
